
import Vue from 'vue';

interface Props {
  diameter: number;
  totalPercent: number;
  currentPercent: number;
  gradientStartColor: string;
  gradientStopColor: string;
  strokeWidth: number;
  innerStrokeWidth: number;
  strokeLinecap: string;
  animateSpeed: number;
  innerStrokeColor: string;
  timingFunc: string;
  mode: string;
}

interface Data {
  gradientAnimation: null;
  currentAngle: number;
  strokeDashoffset: number;
}

interface Methods {
  animate: () => void;
}

interface Computed {
  radius: number;
  circumference: number;
  stepSize: number;
  finishedPercentage: number;
  circleDiameter: number;
  circleRadius: number;
  outerCircleStyle: any | null;
  progressStyle: any;
  strokeStyle: any;
  innerCircleStyle: any;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    diameter: {
      type: Number,
      required: false,
      default: 200,
    },
    totalPercent: {
      type: Number,
      required: false,
    },
    currentPercent: {
      type: Number,
      required: true,
      default: 0,
    },
    gradientStartColor: {
      type: String,
      required: false,
    },
    gradientStopColor: {
      type: String,
      required: false,
    },
    strokeWidth: {
      type: Number,
      required: false,
      default: 10,
    },
    innerStrokeWidth: {
      type: Number,
      required: false,
      default: 10,
    },
    strokeLinecap: {
      type: String,
      required: false,
      default: 'round',
    },
    animateSpeed: {
      type: Number,
      required: false,
      default: 1000,
    },
    innerStrokeColor: {
      type: String,
      required: false,
    },
    timingFunc: {
      type: String,
      required: false,
      default: 'linear',
    },
    mode: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      gradientAnimation: null,
      currentAngle: 0,
      strokeDashoffset: this.totalPercent !== 0 ? Math.PI * (this.diameter - this.innerStrokeWidth * 2) : 0,
    };
  },
  computed: {
    radius() {
      return this.diameter / 2;
    },
    circumference() {
      return Math.PI * this.circleDiameter;
    },
    stepSize() {
      if (this.totalPercent === 0) {
        return 0;
      }
      return 100 / this.totalPercent;
    },
    finishedPercentage() {
      return this.stepSize * this.currentPercent;
    },
    circleDiameter() {
      return this.diameter - this.innerStrokeWidth * 2;
    },
    circleRadius() {
      return this.circleDiameter / 2;
    },
    outerCircleStyle() {
      if (this.mode !== 'embed') {
        return {
          height: `${this.diameter}px`,
          width: `${this.diameter}px`,
        };
      } else {
        return null;
      }
    },
    progressStyle() {
      return {
        height: `${this.diameter}px`,
        width: `${this.diameter}px`,
        strokeWidth: `${this.strokeWidth}px`,
        //strokeDashoffset: this.strokeDashoffset,
        //transition: `stroke-dashoffset ${this.animateSpeed}ms ${this.timingFunc}`,
      };
    },
    strokeStyle() {
      return {
        height: `${this.diameter}px`,
        width: `${this.diameter}px`,
        strokeWidth: `${this.innerStrokeWidth}px`,
      };
    },
    innerCircleStyle() {
      return {
        width: `${this.circleDiameter}px`,
      };
    },
  },
  mounted() {
    // this.totalPercent !== 0 && setTimeout(() => this.animate(), 200);
  },
  methods: {
    animate() {
      // this.strokeDashoffset = ((100 - this.finishedPercentage) / 100) * this.circumference;
    },
  },
});
